import { useEffect } from "react";
import { BsExclamationDiamond } from "react-icons/bs";

export default function PaymentFailed() {

  useEffect(() => {
    setTimeout(() => {
      window.close();
    }, 3000);
  });

  return (
    <div className="relative flex min-h-screen min-h-[100dvh] flex-col items-center justify-center overflow-hidden bg-gradient-to-br from-slate-900 via-red-950 to-slate-900 px-4 py-10">

      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-red-500/20 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-32 -right-16 h-80 w-80 rounded-full bg-red-400/10 blur-3xl"></div>

      <div className="rise relative w-full max-w-[440px] rounded-3xl bg-white p-8 text-center shadow-2xl shadow-slate-950/40 ring-1 ring-white/10">

        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-3xl bg-red-50 ring-1 ring-red-100">
          <BsExclamationDiamond size={44} className="text-red-500" />
        </div>

        <div className="mt-5 text-xl font-bold tracking-tight text-slate-900">Payment Failed!</div>

        <div className="mt-3 text-sm leading-relaxed text-slate-500">
          <span dangerouslySetInnerHTML={{ __html: `We’re sorry, but your payment could not be processed at this time. Please check your payment details and try again.<br /><br />If you continue to experience issues, <a href="https://kptd.ph/remote#contact" class="font-semibold text-blue-600 hover:underline">click here</a> to contact our support team or email <span class="font-semibold text-slate-700">support@kptd.ph</span>` }} />
        </div>

        <a href="/" className="mt-7 inline-flex min-h-[44px] w-full items-center justify-center rounded-xl bg-gradient-to-b from-blue-500 to-blue-600 px-4 text-sm font-bold text-white shadow-lg shadow-blue-600/25 transition hover:from-blue-600 hover:to-blue-700">
          Back to Remote VPN
        </a>

      </div>
    </div>
  );
}
